export default "__VITE_ASSET__la_wCDiS__"